<template>
  <section v-if="propLancamento">
    <div class="row pl-4">
      <span class="col-5 table-infos-title">Serviços</span>
      <span class="col-1 table-infos-title">Qtd</span>
      <span class="col-2 table-infos-title">Valor Unitário</span>
      <span class="col-2 table-infos-title">Valor Total</span>
    </div>
    <div class="row pl-4">
      <span class="col-5 pl-5">{{ propLancamento.ato }}</span>
      <span class="col-1">{{ 1 }}</span>
      <input id="custa_valor"
             v-money="money"
             :value="propLancamento.valor_total"
             disabled
             class="col-2"
             name="custa_ipesp"
             size="sm"
             trim>
      <input id="custa_valor_total_custa"
             v-money="money"
             :value="propLancamento.valor_total"
             disabled
             class="col-2"
             name="valor_total"
             size="sm"
             trim>
    </div>
  </section>
</template>

<script>

  // Imports
  import { VMoney } from 'v-money'

  export default ({
    name: 'ItemTableLancamento',
    directives: {
      money: VMoney
    },
    props: {
      propLancamento: {type: Object, default: null},
    },
    data () {
      return {
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
      }
    },
    methods: {

    }
  })
</script>